import axios from "axios";

export const apiClient = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL || '',
    responseType: 'json',
    headers: {
        'Content-Type': 'application/json',
        'X-RCMS-API-ACCESS-TOKEN': process.env.REACT_APP_SECRET_TOKEN
    },
});